import moment from 'moment';
import queryString from 'qs';

export const getReportHostSummaryRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.host?.brand?.length) queries['brandName'] = `[${queryParams?.host?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.search) queries['search'] = queryParams?.search;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;
  if (queryParams?.host?.startedAt) queries['startedAt'] = moment(queryParams?.host?.startedAt).format('YYYY-MM-DD');
  if (queryParams?.host?.endedAt) queries['endedAt'] = moment(queryParams?.host?.endedAt).format('YYYY-MM-DD');

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportHostSummaryRequest;
